<div class="banner_container"  >
  <a target="_blank" href="https://www.oppo.com/eg/smartphones/series-reno/reno6-5g/?utm_source=facebook&utm_medium=social&utm_campaign=EGY-Reno65G-PUBGCompetition&utm_term=fbig&utm_content=Egypt-AR-P-HS-PUBGCompetition">
    <img class="img-responsive hidden-xs" src="assets/img/oppo-egypt/Artboard-1.jpg" alt=""  >
    <img src="assets/img/oppo-egypt/Artboard%204.png" class="img-responsive  hidden-lg hidden-md hidden-sm" alt="">

  </a>
</div>

<ng-container *ngIf="!eventService.loadEventTournaments; else loading">
<ng-container *ngIf="(eventService.eventTournaments|async)?.data != 0; else nodata">

  <div class="tournamentsCon" >
<!--    <div class="items" *ngFor="let tournament of (eventService.eventTournaments|async)?.data">-->

<!--      <div class="items-status" [ngClass]="{'active':tournament.status=='Waiting Players to Join',-->
<!--                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress'}"></div>-->
      <a class="tournamentCard" *ngFor="let tournament of (eventService.eventTournaments|async)?.data"
         href="https://www.gbarena.com/tournaments/{{ tournament.code }}"
        >

        <div class="topBanner">
          <img src="{{tournament.cover_picture}}" class="img-responsive" >
          <a class="new_button" href="https://www.gbarena.com/tournaments/{{tournament.code}}">
            Join Now
          </a>
        </div>
        <div class="body">
          <h1>{{ tournament.name }}</h1>
          <div class="midCon">
            <div class="date">
              <div class="item">
                <svg xmlns="http://www.w3.org/2000/svg" width="14.55" height="16.628">
                  <path data-name="Icon awesome-calendar-alt" d="M0 15.069a1.559 1.559 0 0 0 1.559 1.559h11.432a1.559 1.559 0 0 0 1.559-1.559V6.236H0zM10.393 8.7a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39V10a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zm0 4.157a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39v1.3a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zM6.236 8.7a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39V10a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zm0 4.157a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39v1.3a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zM2.079 8.7a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39V10a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zm0 4.157a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39v1.3a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zM12.991 2.079h-1.559V.52a.521.521 0 0 0-.52-.52H9.873a.521.521 0 0 0-.52.52v1.559H5.2V.52A.521.521 0 0 0 4.677 0h-1.04a.521.521 0 0 0-.52.52v1.559H1.559A1.559 1.559 0 0 0 0 3.637V5.2h14.55V3.637a1.559 1.559 0 0 0-1.559-1.558z" style="fill:#fff"/>
                </svg>


                {{tournament.start_at | date:'d/M/yy'}}</div>
              <div class="item">
                <svg xmlns="http://www.w3.org/2000/svg" width="16.574" height="16.574">
                  <path data-name="Icon awesome-clock" d="M8.85.563a8.287 8.287 0 1 0 8.287 8.287A8.286 8.286 0 0 0 8.85.563zm1.908 11.7L7.81 10.119a.4.4 0 0 1-.163-.319V4.171a.4.4 0 0 1 .4-.4h1.6a.4.4 0 0 1 .4.4v4.6l2.122 1.544a.4.4 0 0 1 .087.561l-.942 1.3a.4.4 0 0 1-.556.085z" transform="translate(-.563 -.563)" style="fill:#fff"/>
                </svg>
                {{tournament.start_at | date:'shortTime'}}</div>
            </div>
            <div class="status" style="display: flex; justify-content: flex-start; align-items: center;">

              <div class="icon"
                   [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress',
                                  'closed':tournament.status=='Registration Closed'}"></div>

              <p *ngIf="tournament.status=='Waiting Players to Join'">Open</p>
              <p *ngIf="tournament.status=='inprogress'">In Progress</p>
              <p *ngIf="tournament.status=='Finished'">Finished</p>
              <p *ngIf="tournament.status=='Registration Closed'">Closed</p>

            </div>
          </div>


        </div>
      </a>

  </div>
</ng-container>
</ng-container>

<ng-template #nodata >
  <div class="no-data " >
    <h2>No Tournaments Created yet</h2>

  </div>
</ng-template>


<ng-template #loading>
  <app-loading-indicator></app-loading-indicator>
</ng-template>
